import styled from "styled-components";

export const Card = styled.div`
  width: 100%;
  padding: 20px;
  height: 100%;
  border-radius: 8px;
  position: relative;
  background-color: white;
  .wrap-header {
    display: flex;
    justify-content: space-between;
    align-items: start;
  }
  .wrap-header .img {
    width: 50px;
    height: auto;
  }
  .wrap-header .dot {
    color: #8490a5;
    font-size: 22px;
    cursor: pointer;
  }
  .title {
    padding-top: 20px;
    font-size: 20px;
    color: #0c0a64;
    font-weight: 600;
    line-height: 20px;
  }
  .desc {
    font-size: 15px;
    color: #8490a5;
    padding-top: 10px;
    font-weight: 400;
    line-height: 24px;
    margin: 0px;
    padding: 0;
  }
  .more {
    color: #6688ff;
  }
  & .card-header {
    font-weight: 500;
    font-size: 15px;
    color: #343c6a;
  }

  & .three-dots {
    cursor: pointer;
    font-size: 20px;
  }
`;
export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 43px;
  z-index: 1;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8490a5;
  font-size: 12px;
  .editicon {
    color: #8490a5;
  }
  :hover {
    color: #6610f2;
    .editicon {
      color: #6610f2;
    }
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  color: #8490a5;
  gap: 6px;
  .delicon {
    color: #8490a5;
  }
  :hover {
    color: red;
    .delicon {
      color: red;
    }
  }
`;
